import React from 'react';
import PropTypes from 'prop-types';

import IconPlay from './svg/IconPlay';

function ButtonPlay({ className, style, onClick }) {
  return (
    <div onClick={onClick} className={className} style={{...style}}>
      <IconPlay />
    </div>
  )
}

ButtonPlay.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
}

export default ButtonPlay;
